/** Subscribes to a CSS media query and re-renders when its match state changes. */

import { useSyncExternalStore } from "react";

export function useMediaQuery(query: string): boolean {
  const subscribe = (onChange: () => void) => {
    if (typeof window === "undefined" || !window.matchMedia) return () => {};
    const mql = window.matchMedia(query);
    mql.addEventListener("change", onChange);
    return () => mql.removeEventListener("change", onChange);
  };

  const getSnapshot = () => {
    if (typeof window === "undefined" || !window.matchMedia) return false;
    return window.matchMedia(query).matches;
  };

  return useSyncExternalStore(subscribe, getSnapshot, () => false);
}

/** True below Tailwind's `md` breakpoint (768px) — i.e. phone-sized viewports. */
export function useIsMobile(): boolean {
  return useMediaQuery("(max-width: 767px)");
}
